import React, { useEffect, useState } from "react";
import { errorNotification, successNotification } from "../Generic/Notifications";
import { Table, Tbody, Tcol, Thead, Trow } from "../Generic/Table";
import { connect } from "react-redux";
import styled from "styled-components";
import EmptyState from "../Generic/EmptyState";
import Loader from "../Generic/Loader";
import { beautifyKey } from "../util/util";
import TaskService from "./services";

const Page = styled.div`
	display: flex;
	height: max-content;
	overflow-y: auto;
	overflow-x: hidden;
	flex-direction: column;
	text-align: left;
	width: 100%;
	padding: 1rem;
`;

const Header = styled.div`
    display:flex;
    font-size:2rem;
    margin:1rem 0 0 0.5rem;
`;

const CenteredContainer = styled.div`
	width: 100%;
	height: max-content;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: ${(props) => props.margin};
`;

function dateToString(date) {
	return new Date(date).toLocaleString();
}

const ActiveTasks = (props) => {

	const { kitchenId } = props;
    const [activeTasks, setActiveTasks] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const [flaggedForRemoval, setFlaggedForRemoval] = useState([]);

	async function getActiveTasks() {
		setLoading(true);
		const { data, error } = await TaskService.getActiveTasks(kitchenId);
		if(data) {
			setActiveTasks(data);
		}
		if(error) {
			setError(error);
		}
		setLoading(false);
	}

	async function retryCall() {
		setError('');
		setLoading(true);
		getActiveTasks();
	}

	async function handleTaskKillRequest(taskId) {
		const payload = { taskId };
		setFlaggedForRemoval(prev => ([ ...prev, taskId]));
		const { data, error } = await TaskService.killActiveTask(payload);
		if(data) {
			successNotification('Task Cleared');
			getActiveTasks()
		}
		if(error) {
			errorNotification('Failed to clear active task');
		}
		setFlaggedForRemoval(prev => prev.filter(task => task !== taskId));
	}

	function renderActiveTasks(activeTasks, loading, error) {
		if(loading) {
			return <CenteredContainer> <Loader /> </CenteredContainer>;
		}
		if(error) {
			return <EmptyState message="Could not fetch active tasks" retry={retryCall} ></EmptyState> ;
		}
		if(!activeTasks || !activeTasks.length) {
			return <EmptyState message="No Active tasks found" retry={retryCall} retryButtonText="Search again" ></EmptyState> ;
		}

		const tasksRenderData = activeTasks ? activeTasks.map((task) => {
			const { _id, taskType, taskGroupId, estimatedStartTime, estimatedEndTime } = task,
				startTimeString = estimatedStartTime ? dateToString(estimatedStartTime) : "-",
			 	endTimeString = estimatedEndTime ? dateToString(estimatedEndTime) : "-",
				isgettingRemoved = flaggedForRemoval.includes(_id);
			return (
				<Trow disabled={isgettingRemoved} hoverEffect={false} >
					<Tcol borderRadius="10px 0 0 10px" >{_id}</Tcol>
					<Tcol>{beautifyKey(taskType)}</Tcol>
					<Tcol>{taskGroupId}</Tcol>
					<Tcol>{startTimeString}</Tcol>
					<Tcol>{endTimeString}</Tcol>
					<Tcol borderRadius="0 10px 10px 0" >
						<span onClick={() => handleTaskKillRequest(_id)} class="material-symbols-outlined remove-symbol">
							delete
						</span>
					</Tcol>
				</Trow>
			);
		}) : "";
		return (
			<Table>
				<Trow head >
					<Thead>Task ID</Thead>
					<Thead>Task Type</Thead>
					<Thead>Task Group ID</Thead>
					<Thead>Estimated Start Time</Thead>
					<Thead>Estimated End Time</Thead>
					<Thead></Thead>
				</Trow>
				<Tbody>{tasksRenderData}</Tbody>
			</Table>
		);
	}

	useEffect(() => {
		getActiveTasks();
	}, []);

	return (
		<Page>
			<Header>
				Active Tasks
			</Header>
			{renderActiveTasks(activeTasks, loading, error)}
		</Page>
	);
};

const mapStatetoProps = (state) => {
	const { kitchen, landing } = state;
	return {
		kitchenId: landing.kitchenId,
		machineID: landing.machineID,
		...kitchen,
	};
};

export default connect(mapStatetoProps, {})(ActiveTasks);
